












import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Loading extends Vue {
  @Prop({ default: "point" })
  private type?: string;
}
